import * as React from 'react';
import { Button, TextArea, Modal } from 'semantic-ui-react';
import { Tags } from '../Tags/Tags';
import { MessageCategory } from '../../models';
import { MESSAGE_MAX_CHARS, MAX_MESSAGES } from '../../constants';

export interface AddMessageSectionProps {
  messageCategories: MessageCategory[];
  hasReachedMax: boolean;
  addMessage(message: string, tags: number[]): void;
  hideAddMessageSection(): void;
}

export interface AddMessageSectionState {
  message: string;
  tags: number[];
}

export class AddMessageSection extends
  React.Component<AddMessageSectionProps, AddMessageSectionState> {
  txtArea: TextArea;
  selectedTags: number[] = [];

  constructor(props: AddMessageSectionProps, state: AddMessageSectionState) {
    super(props, state);
    this.state = { message: '', tags: [] };
  }

  handleMessageChange = (event: React.SyntheticEvent<HTMLTextAreaElement>) => {
    this.setState({ message: this.sliceCharactersIfNeeded(event.currentTarget.value) });
  }

  sliceCharactersIfNeeded = (text: string): string => {
    if (text && text.length > MESSAGE_MAX_CHARS) {
      return text.slice(0, MESSAGE_MAX_CHARS);
    }
    return text;
  }

  onSaveClick = () => {
    this.props.addMessage(this.state.message, this.state.tags.filter(t => t > 0));
    this.setState({ message: '', tags: [] });
  }

  onTagSelectionChanged = (tags: number[]) => {
    this.setState({ tags });
  }


  setupRef = (ta: any) => {
    if (ta) {
      ta.focus();
    }
  }

  render() {
    const { hideAddMessageSection, messageCategories, hasReachedMax } = this.props;
    const isSaveDisabled = this.state.tags.length === 0 || this.state.message === '';
    const valueLength = (this.state.message && this.state.message.length) || 0;
    return (
      <div className="addMessageSection">
        <Modal size="tiny" open={true}>
          <Modal.Header>
            New Message
            </Modal.Header>
           
          <Modal.Content>
            <TextArea
              className="addMessageTextarea"
              ref={this.setupRef}
              value={this.state.message}
              placeholder="Type your message..."
              onChange={this.handleMessageChange}
              id="addMessageText"
            />
            <span 
              className="addMessageSectionTotalChars" 
              style={{ color: valueLength === MESSAGE_MAX_CHARS ? 'orange' : 'unset' }}
            >
            {valueLength}/{MESSAGE_MAX_CHARS}
            </span>
            <div className="categoryDropdown">
              <Tags
                messageCategories={messageCategories}
                selectedTags={this.selectedTags}
                onTagSelectionChanged={this.onTagSelectionChanged}
              />
            </div>
          </Modal.Content>
          { hasReachedMax && 
                <div className="reachedMaxContainer">
                You have reached the maximum number of Canned Messages. 
                Only the {MAX_MESSAGES} most recent will be displayed 
                </div>
              }

          <Modal.Actions className="addActions">
            <Button
              className="addMessageCancel"
              onClick={hideAddMessageSection}
              circular={true}
              basic={true}
              color="blue"
            >
              Nevermind
            </Button>
            <Button
              primary={true}
              className="addMessageSave"
              onClick={this.onSaveClick}
              disabled={isSaveDisabled}
              circular={true}
            >
              Save
            </Button>
          </Modal.Actions>
        </Modal>

      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/AddMessage/AddMessageSection.tsx